<script setup lang="ts">
import { useCreateTrainingStore } from "~/store/trainings/create-training.store";
import { storeToRefs } from "pinia";
import Tooltip from "~/components/Common/Tooltip.vue";
import RadioInput from "~/components/Common/Inputs/RadioInput.vue";

import AreaInput from "~/components/Common/Inputs/AreaInput.vue";

const createTrainingStore = useCreateTrainingStore();
const { training, readonly } = storeToRefs(createTrainingStore);
</script>
<template>
  <h3 class="heading_3_demi">Modalités</h3>
  <div v-if="training.modalities" class="mt-4 px-4 text-secondary-color">
    <div class="fields">
      <span>Accès à la formation</span>
      <div class="flex flex-col gap-2">
        <label class="flex gap-2 w-fit" :class="readonly ? 'cursor-not-allowed' : 'cursor-pointer'">
          <RadioInput
            :disabled="readonly"
            :checked="!training.modalities.noRequest"
            @update:model-value="training.modalities.noRequest = false"
          ></RadioInput>
          <span>L'inscription doit être validée par un Admin</span>
        </label>
        <label class="flex gap-2 w-fit" :class="readonly ? 'cursor-not-allowed' : 'cursor-pointer'">
          <RadioInput
            :disabled="readonly"
            :checked="training.modalities.noRequest"
            @update:model-value="training.modalities.noRequest = true"
          ></RadioInput>
          <span>L'inscription est libre : le participant peut s'inscrire depuis le catalogue</span>
        </label>
      </div>
    </div>
    <div class="fields">
      <div class="flex gap-2 items-center">
        <h4 class="body_med text-black">Commentaire Formation</h4>
        <Tooltip :position="'top-mid'">
          <template #content>
            <div class="flex w-[342px] gap-[8px]">
              <img src="/icons/emojis/eyes.svg" alt="" :style="{ height: '16px', width: '16px' }" />
              <span
                >Ce commentaire est transmis à chaque nouvelle session créée, et peut faire l'objet d'un ajout sur les
                convocations générées automatiquement)
              </span>
            </div>
          </template>
        </Tooltip>
      </div>
      <AreaInput
        v-model="training.modalities.comment"
        :disabled="readonly"
        class="textarea__input"
        style="min-height: 116px"
        placeholder="Ajouter un commentaire"
      ></AreaInput>
    </div>
  </div>
</template>
<style scoped lang="scss">
.fields {
  @apply flex flex-col mb-8 gap-2;
}
</style>
